import(/* webpackMode: "eager" */ "/app/apps/admin/src/app/(blank)/layout.tsx");
